import {
  DemoInformationIntroductionBanner,
  DemoInformationSection3Banner,
} from '@/constant/imgImport';
import {
  EInformationTabSectionKey,
  TEnterpriseProfileInformationTabSection,
} from '@/interfaces/enterprise-profile/information_tab.interface';

export const hashInformationSectionName = {
  [EInformationTabSectionKey.Section1]: 'Thông tin 1',
  [EInformationTabSectionKey.Section2]: 'Thông tin 2',
  [EInformationTabSectionKey.CollabOrgs]: 'Doanh nghiệp hợp tác',
  [EInformationTabSectionKey.Section3]: 'Thông tin 3',
  [EInformationTabSectionKey.FrequentlyAsks]: 'Câu hỏi thường gặp',
};

export const defaultInformationSection: TEnterpriseProfileInformationTabSection =
  [
    {
      sectionName:
        hashInformationSectionName[EInformationTabSectionKey.Section1],
      sectionKey: EInformationTabSectionKey.Section1,
      elements: {
        image: DemoInformationIntroductionBanner,
      },
      isActive: true,
    },
    {
      sectionName:
        hashInformationSectionName[EInformationTabSectionKey.Section2],
      sectionKey: EInformationTabSectionKey.Section2,
      elements: {
        data: [
          {
            title: 'Display 2',
            content:
              'Việc thu thập dữ liệu chủ yếu trên Doccen.vn bao gồm: email, điện thoại, tên đăng nhập, mật khẩu đăng nhập (thành viên). Đây là các thông tin mà Doccen.vn cần thành viên cung cấp bắt buộc khi đăng ký sử dụng dịch vụ để Doccen.vn liên hệ xác nhận khi khách hàng đăng ký sử dụng dịch vụ trên website nhằm đảm bảo quyền lợi cho cho người tiêu dùng.Các thành viên sẽ tự chịu trách nhiệm về bảo mật và lưu giữ mọi hoạt động sử dụng dịch vụ dưới tên đăng ký, mật khẩu và hộp thư điện tử của mình. Ngoài ra, thành viên có trách nhiệm thông báo kịp thời cho Doccen.vn về những hành vi sử dụng trái phép, lạm dụng, vi phạm bảo mật, lưu giữ tên đăng ký và mật khẩu của bên thứ ba để có biện pháp giải quyết phù hợp.',
          },
          {
            title: 'Display 2',
            content:
              'Việc thu thập dữ liệu chủ yếu trên Doccen.vn bao gồm: email, điện thoại, tên đăng nhập, mật khẩu đăng nhập (thành viên). Đây là các thông tin mà Doccen.vn cần thành viên cung cấp bắt buộc khi đăng ký sử dụng dịch vụ để Doccen.vn liên hệ xác nhận khi khách hàng đăng ký sử dụng dịch vụ trên website nhằm đảm bảo quyền lợi cho cho người tiêu dùng.Các thành viên sẽ tự chịu trách nhiệm về bảo mật và lưu giữ mọi hoạt động sử dụng dịch vụ dưới tên đăng ký, mật khẩu và hộp thư điện tử của mình. Ngoài ra, thành viên có trách nhiệm thông báo kịp thời cho Doccen.vn về những hành vi sử dụng trái phép, lạm dụng, vi phạm bảo mật, lưu giữ tên đăng ký và mật khẩu của bên thứ ba để có biện pháp giải quyết phù hợp.',
          },
        ],
      },
      isActive: true,
    },
    {
      sectionName:
        hashInformationSectionName[EInformationTabSectionKey.CollabOrgs],
      sectionKey: EInformationTabSectionKey.CollabOrgs,
      isActive: true,
      elements: {
        title: '10,000 + Doanh nghiệp hợp tác',
        image:
          'https://blogs.microsoft.com/wp-content/uploads/prod/2012/08/8867.Microsoft_5F00_Logo_2D00_for_2D00_screen.jpg',
      },
    },
    {
      sectionName:
        hashInformationSectionName[EInformationTabSectionKey.Section3],
      sectionKey: EInformationTabSectionKey.Section3,
      elements: {
        title: 'Display 2',
        content:
          'Việc thu thập dữ liệu chủ yếu trên Doccen.vn bao gồm: email, điện thoại, tên đăng nhập, mật khẩu đăng nhập (thành viên). Đây là các thông tin mà Doccen.vn cần thành viên cung cấp bắt buộc khi đăng ký sử dụng dịch vụ để Doccen.vn liên hệ xác nhận khi khách hàng đăng ký sử dụng dịch vụ trên website nhằm đảm bảo quyền lợi cho cho người tiêu dùng.Các thành viên sẽ tự chịu trách nhiệm về bảo mật và lưu giữ mọi hoạt động sử dụng dịch vụ dưới tên đăng ký, mật khẩu và hộp thư điện tử của mình. Ngoài ra, thành viên có ',
        image: DemoInformationSection3Banner,
      },
      isActive: true,
    },
    {
      sectionName:
        hashInformationSectionName[EInformationTabSectionKey.FrequentlyAsks],
      sectionKey: EInformationTabSectionKey.FrequentlyAsks,
      elements: {
        questions: new Array(4).fill({
          question: 'Chúng tôi là ai?',
          answer:
            'If someone has uploaded their contacts and it includes your mobile phone number or email address, you may show up as If someone has uploaded their contacts and it includes your mobile phone number or email address, you may show up your mobile phone num',
        }),
      },
      isActive: true,
    },
  ];
